import React, { useState } from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"
import { validateEmail } from "../../helpers/email-input.helper"
import {
  CheatsheetCTAContainer,
  ContentContainer,
  CheatsheetCTASubTitle,
  CheatsheetCTAInput,
  EmailSubscribeStatus,
  StatusIcon,
  CheatsheetCTAFormContainer,
} from "./cheatsheet-CTA.styles"
import ButtonLink from "../btn-collections/btn-collections.component"
import { CheatsheetEventHandler } from "../../../email/cheatsheets.function"

const CheatsheetCTA = ({ group, slug, name }) => {
  const updateGTM = (status) => {
    dataLayerHelper({
      event: "emailSubscriber",
      location: `Cheat-Sheet: ${slug}`,
      status,
      cta_identifier: "CheatsheetCTA",
    })
  }

  const postSubscriber = async (email) => {
    // Mac wants to slowly transition cheatsheets to CIO due to the number of cheatsheets
    // This array contains the cheatsheets that will be transitioned to CIO

    const cioCheetsheets = [
      "python-cheat-sheet",
      "linux-commands-cheat-sheet",
      "data-structures-and-algorithms-cheat-sheet",
      "big-o-cheat-sheet",
      "node-js-cheat-sheet",
      "javascript-cheatsheet-the-advanced-concepts",
      "react-cheat-sheet",
      "angular-cheat-sheet",
      "rust-cheat-sheet",
      "terraform-cheat-sheet",
      "typescript-cheat-sheet",
      "golang-cheat-sheet",
      "ui-ux-design-cheat-sheet",
      "react-native-cheat-sheet",
    ]

    // If cheatsheet is in the array, then use the CIO cheatsheet handler
    if (cioCheetsheets.includes(slug)) {
      try {
        // VALIDATE EMAIL
        if (!validateEmail(email)) {
          setStatusText(
            `Please provide a valid email address to stay up to date!`
          )
          setStatusStyle(`error`)
          return
        }
        const handler = await CheatsheetEventHandler({
          email,
          cheatsheet: slug,
        })
        if (handler.status === 200) {
          updateGTM("Subscribe Success")
          setStatusText(`Great decision, check your email for your PDF!`)
          setStatusStyle(`success`)
          setEmail("")
        } else {
          setStatusText(`An error occured, please try again later!`)
          setStatusStyle(`error`)
        }
      } catch (error) {
        setStatusText(`An error occured, please try again later!`)
        setStatusStyle(`error`)
      }
    }
    // Else use the MailerLite handler
    else {
      if (validateEmail(email)) {
        try {
          const response = await fetch(
            "/.netlify/functions/newsletter-mailerlite",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email, group, slug }),
            }
          )

          if (response.status === 200) {
            updateGTM("Subscribe Success")
            setStatusText(`Great decision, check your email for your PDF!`)
            setStatusStyle(`success`)
            setEmail("")
          } else {
            setStatusText(`An error occured, please try again later!`)
            setStatusStyle(`error`)
          }
        } catch (error) {
          setStatusText(`An error occured, please try again later!`)
          setStatusStyle(`error`)
        }
      } else {
        setStatusText(
          `Please provide a valid email address to get the PDF of this cheatsheet!`
        )
        setStatusStyle(`error`)
      }
    }
  }

  const [email, setEmail] = useState("")
  const [statusText, setStatusText] = useState("")
  const [statusStyle, setStatusStyle] = useState("default")
  const handleEmailChange = (e) => {
    setEmail(e.target.value.trim())
  }
  const displayStatusIcon = (state) => {
    switch (state) {
      case "success":
        return (
          <StatusIcon statusStyle={state}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 25 25"
              width="25"
              height="25"
            >
              <circle fill="#1c8000" cx="11.9" cy="11.9" r="11.5" />
              <path
                stroke="white"
                d="M 17.3789 6.78271 L 8.33081 15.8308 L 4.65625 12.1562"
              />
            </svg>
          </StatusIcon>
        )

      case "error":
        return (
          <StatusIcon statusStyle={state}>
            <svg
              viewBox="0 0 25 25"
              width="25"
              height="25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle fill="#EB000E" cx="11.9" cy="11.9" r="11.5" />
              <line
                x1="16.3809"
                y1="6.78275"
                x2="6.78421"
                y2="16.3794"
                stroke="white"
              />
              <line
                x1="16.4121"
                y1="16.3794"
                x2="6.81539"
                y2="6.78275"
                stroke="white"
              />
            </svg>
          </StatusIcon>
        )
      default:
        return null
    }
  }

  const displayStatusText = (state) => {
    if (state !== "default") {
      return (
        <EmailSubscribeStatus statusStyle={state}>
          {statusText}
        </EmailSubscribeStatus>
      )
    } else return null
  }

  return (
    <CheatsheetCTAContainer mt={40} mb={50}>
      <ContentContainer className="content-container">
        <h4>Want to download a PDF version of this {name}?</h4>
        <div
          dangerouslySetInnerHTML={{
            __html: `<p>Enter your email below and we'll send it to you 👇</p>`,
          }}
        />

        {displayStatusText(statusStyle)}

        <CheatsheetCTAFormContainer>
          <CheatsheetCTAInput
            statusStyle={statusStyle}
            placeholder="Enter Your Email Address"
            onKeyDown={(e) =>
              e.key === "Enter" ? postSubscriber(email, group) : null
            }
            onChange={handleEmailChange}
            type="email"
            autoComplete="email"
          />

          <ButtonLink
            isButton
            onClick={() => postSubscriber(email)}
            style={{ minWidth: "160px", padding: 0 }} // ensure long text don't overflow to the next line
          >
            Send Me The PDF
          </ButtonLink>

          {displayStatusIcon(statusStyle)}
        </CheatsheetCTAFormContainer>

        <CheatsheetCTASubTitle>Unsubscribe anytime.</CheatsheetCTASubTitle>
      </ContentContainer>
    </CheatsheetCTAContainer>
  )
}

export default CheatsheetCTA
